import InstallationListTable from './InstallationListTable';

export default InstallationListTable;
